// General
import "./eye-color-filter-dialog.scss";
import { useEffect, forwardRef } from "react";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { updateEyeColorFilterDialog } from "../../../../../redux/store/dialogStore";
// react-gtm-module
import TagManager from "react-gtm-module";
// Material UI
import { Dialog, Slide } from "@mui/material";
// Components
import EyeColorFilter from "../../../elements/filters/eye-color-filter/eye-color-filter";

const EyeColorFilterDialog = () => {
  // Redux variables
  const eyeColorFilterDialog = useSelector(
    (state) => state.dialog.eyeColorFilterDialog
  );
  const dispatch = useDispatch();

  // Lifecycle | Mounted
  useEffect(() => {
    if (!eyeColorFilterDialog) return;

    TagManager.dataLayer({
      dataLayer: {
        event: "PWA-EyeColorFilter-Dialog",
      },
    });
  }, [eyeColorFilterDialog]);

  // Event Handlers | MUI Dialog
  const onCloseDialog = () => {
    dispatch(updateEyeColorFilterDialog(false));
  };

  return (
    <Dialog
      className="custom-bottom-sheet-dialog"
      fullScreen
      open={eyeColorFilterDialog}
      TransitionComponent={Transition}
      onClose={onCloseDialog}
    >
      <EyeColorFilter />
    </Dialog>
  );
};

export default EyeColorFilterDialog;

// Render Functions | MUI Dialog | Will not work if inside of the same render as the Dialog
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
